import { useContext } from "react";
import PropTypes from "prop-types";

import { CheckMarkIcon } from "../../client/assets/icons/common/CheckMarkIcon";
import { CompanyContext } from "../CompanyList/CompanyContext";

const BaseCompanyBadge = ({ iconColor, classNames }) => {
	const { company } = useContext(CompanyContext);
	const badgeText = company.fields.companyBadgeText;

	return badgeText ? (
		<div className={classNames?.wrapper}>
			<CheckMarkIcon color={iconColor} />
			<p className={classNames?.text}>{badgeText}</p>
		</div>
	) : null;
};

export default BaseCompanyBadge;

BaseCompanyBadge.propTypes = {
	iconColor: PropTypes.string,
	classNames: PropTypes.object,
};
